module.exports = __webpack_public_path__ + "img/oam.550e73d0.png";